import { render, staticRenderFns } from "./ServerCreate.vue?vue&type=template&id=35201fc0"
import script from "./ServerCreate.vue?vue&type=script&lang=js"
export * from "./ServerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports